import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import "../dashboard/Dashboard.css";
import { getDoctorsWithCustomerRank } from "../../actions/userActions/doctoreWithCustomerAction";
import { getCustomerRank } from "../../actions/userActions/customerRankAction";
import Loader from "../subComponents/Loader";
import { Linechart } from "../subComponents/recharts/Linechart.jsx";
import { Barchart } from "../subComponents/recharts/Barchart.jsx";
import { StackedBarchart } from "../subComponents/recharts/StackedBarchart";
import { getPermissions } from "../../actions/userActions/permissionsAction";
import { Tabular } from "../subComponents/tabular/Tabular";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { generateReport } from "../../actions/userActions/generateReportAction";
import userService from "../../services/user.service";
import No_Data from '../../assets/images/no_data.svg'
import Heading6Regular from "../designSystem/Heading6Regular.jsx";
import CustomButton from "../subComponents/buttons/CustomButton.jsx";
import { Download, RotateCcw } from "lucide-react";
import DashboardStats from "./Stats.jsx";
import { getChartSummary } from "../../actions/ChartsAction.js";
import { getStats } from "../../actions/StatsAction.js";
import SearchInput from "../subComponents/search/SearchInput.jsx";
import DynamicTable from "../reuse_components/DynamicTable.jsx";
import CustomFilterSelect from "../designSystem/CustomFilterSelect.jsx";
import CustomPagination from "../subComponents/pagination/CustomPagination.jsx";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector.jsx";
import { getSubOrdinates } from "../../actions/userActions/tasks/taskAction.js";
import BodyLargeMedium from "../designSystem/BodyLargeMedium.jsx";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay.jsx";
import CustomTab from "../designSystem/CustomTab.jsx";
import { t } from "../../locales/translate.js";

function Dashboard() {
  const dispatch = useDispatch();
  const history = useHistory()
  const auth = useSelector((state) => state.auth);
  const user = JSON.parse(localStorage.getItem("user"));
  const [showKol, setShowKol] = useState(false);
  const [selected, setSelected] = useState("");
  const [page, setPage] = useState(1);
  const [selectedTab, setSelectedTab] = useState("Call Average");
  const [callEmployee, setCallEmployee] = useState([]);
  const [callProduct, setCallProduct] = useState([]);
  const [callPracticeLocation, setCallPracticeLocation] = useState([]);
  const [callTable, setCallTable] = useState([]);
  const permissions = JSON.parse(localStorage.getItem('permissionsList'))
  const employeeId = user.result[0] !== undefined ? user.result[0].user.id : false;
  const chartSummaryData = useSelector((state) => state.chart);
  const chartLoading = useSelector((state) => state.chart.loading);
const statsLoading = useSelector((state) => state.stats.loading);
const { doctorsWithCustomer: doctors, loading: doctorsLoading } = useSelector(
  (state) => state.doctors_with_customer_reducer
);
const isLoading = chartLoading || statsLoading || (showKol && doctorsLoading);
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const generateReportPdf = useSelector((state) => state.generate_Report.report);
  const { customerRank, loading: customerRankLoading } = useSelector(
    (state) => state.customer_rank_reducer
  );  
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  useEffect(() => {
    dispatch(getChartSummary());
    dispatch(getStats());
  }, [dispatch]);
  useEffect(() => {
    // First, get customer ranks
    dispatch(getCustomerRank(-1, 10, ""))
      .then(() => {
        dispatch(getSubOrdinates(employeeId, -1, 0, ""));
        dispatch(getPermissions(employeeId));
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }, []);
  const options = !customerRankLoading && customerRank?.result
  ? customerRank.result.map((rank) => ({
      id: rank.customerRankId,
      name: rank.rankName,
    }))
  : [];
  useEffect(() => {
    if (options?.length > 0 && !selected) {
      setSelected(options[0].id);
      fetchDoctorsWithRank(options[0].id);
    }
  }, [options]);
  useEffect(() => {
    if (selected) {
      fetchDoctorsWithRank(selected);
    }
  }, [currentPage, query]);

  // Helper function to fetch doctors with a specific rank
  const fetchDoctorsWithRank = (rankId) => {
    dispatch(getDoctorsWithCustomerRank({
      rankId: rankId,
      pageNumber: currentPage,
      pageSize: itemsPerPage,
      textSearch: query
    }));
  };
  const handleClick = () => {
    dispatch(getChartSummary());
    dispatch(getStats());
    dispatch(getCustomerRank(-1, 10, ""));
    const idToUse = (!selected && options?.length > 0) ? options[0].id : selected;
    if (idToUse) {
      fetchDoctorsWithRank(idToUse);
    }
  };
  const CallAverageChange = () => {
    setShowKol(false);
    setSelectedTab("Call Average");
  };
  const KolChange = () => {
    setShowKol(true);
    setSelectedTab("KOL");
  };

  if (auth.isLoggedIn === false && !user) {
    return <Redirect to="/" />;
  }


  const handleRankChange = (event) => {
    const newRankId = event.target.value;
    setSelected(newRankId);
    setCurrentPage(1);
    fetchDoctorsWithRank(newRankId);
  };
  const handleSearch = (e) => {
    setQuery(e.target.value);
    setCurrentPage(1); 
  };
  const handleSummaryClick = () => {

    const defaultPayload = {
      productCallAverageRequest: {
        productFilters: { product: 0, employeeIds: [0] },
        startTime: new Date().toISOString(),
        endTime: new Date().toISOString()
      },
      employeeCallAverageRequest: {
        employeeFilters: { productIds: [0], employee: 0 },
        startTime: new Date().toISOString(),
        endTime: new Date().toISOString()
      },
      tableCallAverageRequest: {
        tableFilters: { productsIds: [0], employeeIds: [0] },
        startTime: new Date().toISOString(),
        endTime: new Date().toISOString()
      },
      practiceLocationRequest: {
        practiceLocationFilters: { practiceLocation: 0, employeeIds: [0] },
        startTime: new Date().toISOString(),
        endTime: new Date().toISOString()
      }
    };
    const payload = {
      productCallAverageRequest: Object.keys(callProduct).length ? callProduct : defaultPayload.productCallAverageRequest,
      employeeCallAverageRequest: Object.keys(callEmployee).length ? callEmployee : defaultPayload.employeeCallAverageRequest,
      tableCallAverageRequest: Object.keys(callTable).length ? callTable : defaultPayload.tableCallAverageRequest,
      practiceLocationRequest: Object.keys(callPracticeLocation).length ? callPracticeLocation : defaultPayload.practiceLocationRequest
    };
    dispatch(generateReport(payload));

    const body = {
      "productCallAverageRequest": callProduct,
      "employeeCallAverageRequest": callEmployee,
      "tableCallAverageRequest": callTable,
      "practiceLocationRequest": callPracticeLocation,
    }
    dispatch(userService.generateReport(body))

  };


  const onChangeCallEmployee = (newCallEmployee) => {
    setCallEmployee(newCallEmployee)

  }
  const onChangeCallProduct = (newCallProduct) => {
    setCallProduct(newCallProduct)

  }

  const onChangePracticeLocation = (newPracticeLocation) => {
    setCallPracticeLocation(newPracticeLocation)

  }
  const onChangeCallTable = (newCallTable) => {
    setCallTable(newCallTable)

  }
  const doctorColumns = [
    { label: `${t("name")}`, accessor: "name" },
    { label:  `${t("specialization")}`, accessor: "specializationName" },
    { label: `${t("designation")}`, accessor: "rankName" },
    { label:  `${t("city")}`, accessor: "cityName" },
    { label:  `${t("status")}`, accessor: "status" },
  ];
  const doctors_data = !doctorsLoading && doctors?.result ? doctors.result : [];
  const transformedDoctors = doctors_data?.map((doctor) => ({
    ...doctor,
    status: (
      <span className={doctor.active ? "status-badge-active" : "status-badge-inactive"}>
        {doctor.active ? "Active" : "Inactive"}
      </span>
    ),
  }));

  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getDoctorsWithCustomerRank({
      rankId: selected,
      pageNumber: pageNumber,
      pageSize: value,
      textSearch: query
    }));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  return (
    <>
      <div>
        <LoadingOverlay isVisible={isLoading} />
        <div className={isLoading ? "blur-content" : ""}>
          <div>
            <div className="row align-items-center">
              <div
                className={`col-4 mb-4 ${
                  document.body.dir === "rtl" ? "text-right" : ""
                }`}
              >
                {/* Title */}
                <BodyLargeMedium text={t("dashboard")} color="#1E293B" />
              </div>
              {/* Actions */}
              <div
                className="col-8 d-flex justify-content-end align-items-center"
                style={{ gap: "16px" }}
              >
                {/* Refresh Button  */}
                <button
                  onClick={handleClick}
                  className="w-9 h-9 d-flex align-items-center justify-content-center rounded-xl bg-white shadow border-0 p-0"
                  title="Refresh"
                  style={{ minWidth: "36px", minHeight: "36px" }}
                >
                  <RotateCcw size={20} />
                </button>
                <CustomButton
                  text={t("downloadSummary")}
                  width="200px"
                  icon={Download}
                  onClick={handleSummaryClick}
                />
              </div>
            </div>
            {permissions && permissions.includes("CanViewStats") && (
              <DashboardStats />
            )}

            {/* Nav */}
            <div
              style={{
                display: "flex",
                gap: "24px",
                position: "relative",
                padding: "0px 25px",
                borderBottom: "1px solid #DFE4EA",
              }}
            >
              <CustomTab
                label={t("callAverage")}
                isActive={selectedTab === "Call Average"}
                onClick={CallAverageChange}
              />
              <CustomTab
                label={t("kol")}
                isActive={selectedTab === "KOL"}
                onClick={KolChange}
              />
            </div>
          </div>
          <div>
            <div className="row">
              {showKol != true && (
                <div
                  className="col-12 mt-5"
                  style={{ width: "", height: "374px" }}
                >
                  <div className="row justify-content-center mt-2">
                    {!showKol && (
                      <Linechart
                        chartSummaryData={chartSummaryData?.data?.byEmployees}
                        loading={chartLoading}
                        onChangeCallEmployee={onChangeCallEmployee}
                      />
                    )}
                  </div>

                  <div className="row justify-content-center mt-5">
                    {!showKol && (
                      <Barchart
                        chartSummaryData={chartSummaryData?.data?.byProducts}
                        loading={chartLoading}
                        onChangeCallProduct={onChangeCallProduct}
                      />
                    )}
                  </div>

                  <div className="row justify-content-center mt-5">
                    {!showKol && (
                      <StackedBarchart
                        chartSummaryData={
                          chartSummaryData?.data?.byPracticeLocations
                        }
                        loading={chartLoading}
                        onChangePracticeLocation={onChangePracticeLocation}
                      />
                    )}
                  </div>

                  <div className="row justify-content-center mt-5">
                    {showKol != true && (
                      <Tabular onChangeCallTable={onChangeCallTable} />
                    )}
                  </div>
                </div>
              )}
            </div>
            {showKol == true && (
              <>
                <div className="content-wrapper">
                  <div className="pagination">
                    <SearchInput
                      setText={setQuery}
                      text={query}
                      placeholder="Search"
                      onChange={handleSearch}
                    />
                    <div className="flex-align-center">
                      <div className="items-per-page-container">
                        <ItemsPerPageSelector
                          value={itemsPerPage}
                          onChange={handleItemsPerPageChange}
                        />
                      </div>
                      <CustomPagination
                        currentPage={currentPage}
                        totalItems={doctors?.totalCount || 0}
                        itemsPerPage={itemsPerPage}
                        totalPages={doctors?.totalPages || 0}
                        onPageChange={(page) => setCurrentPage(page)}
                      />
                      <CustomFilterSelect
                        label="Rank"
                        value={selected}
                        onChange={handleRankChange}
                        options={options}
                        isLoading={customerRankLoading}
                      />
                    </div>
                  </div>
                </div>
                <DynamicTable
                  data={transformedDoctors}
                  isLoading={false}
                  columns={doctorColumns}
                  showPagination={doctors?.totalCount > 0}
                  currentPage={currentPage}
                  totalItems={doctors?.totalCount}
                  itemsPerPage={itemsPerPage}
                  totalPages={doctors?.totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                  onItemsPerPageChange={handleItemsPerPageChange}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
